import { createLogic } from 'redux-logic'
import Api from '@app/api/contacts'
import handleErrors from '@app/helpers/handleErrors'
import { PATCH_CONTACT } from '@app/constants/contacts/contacts'
import { apiRequestSent, apiRequestFailed, apiRequestDone } from '@app/actions/apiRequest'
import { setPatchContact } from '@app/actions/contacts/contacts'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'

const patchContact = createLogic({
  type: PATCH_CONTACT,
  cancelType: API_REQUEST_CANCEL,

  process({ action }, dispatch, done) {
    const { secrets: { accessToken: { token: AccessToken } } } = store.getState()
    const { form: { contacts: { values: contactData } } } = store.getState()
    dispatch(apiRequestSent(PATCH_CONTACT))
    Api.patchContact(AccessToken, action.id, contactData)
      .then((response) => {
        dispatch(setPatchContact(response.data))
        dispatch(apiRequestDone(PATCH_CONTACT))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('patchContact failed without error')
        }
      })
      .then(() => done())
  },
})

export default patchContact
